import { axios, BaseApiUrl } from '../axios_config';

// 获取移动端菜单列表
export const getPDAMenu = params =>{
    return axios.get(`${BaseApiUrl}/PDA/GetPDAMenu`, { params }).then(res => res.data)
}

// 获取移动端签收列表
export const getSignList = params =>{
    return axios.post(`${BaseApiUrl}/SignFor/GetSignForList`, { ...params }).then(res => res.data)
}

// 获取移动端部门
export const getDepartmentList = params =>{
    return axios.get(`${BaseApiUrl}/Util/GetOrgDepartmentList`, { params }).then(res => res.data);
}

// 获取移动端签收送货明细
export const getDeliveryNo = params =>{
    return axios.get(`${BaseApiUrl}/SignFor/GetSignForByDeliveryNo`, { params }).then(res => res.data);
}

// 移动端添加签收图片
export const insertSignForImage = params =>{
    return axios.post(`${BaseApiUrl}/SignFor/InsertSignForImage`, { ...params }).then(res => res.data);
}

// 获取签收图片
export const getSignForImage = params =>{
    return axios.get(`${BaseApiUrl}/SignFor/GetSignForImage`, { params }).then(res => res.data);
}

// 移动端确认签收
export const submitSignFor = params =>{
    return axios.post(`${BaseApiUrl}/SignFor/SubmitSignFor`, { ...params }).then(res => res.data);
}

// 读取设备数据
export const getScanData = params =>{
    return axios.get(`${BaseApiUrl}/SignFor/GetScanData`, { params }).then(res => res.data);
}
